import OutsideButton from '@gaia/components/OutsideButton';
import usePersistentState from '@gaia/hooks/usePersistentState';
import {Close} from '@mui/icons-material';
import {Collapse, IconButton, Typography} from '@mui/material';
import type {HTMLProps} from 'react';

import classes from './OutsideAnnouncement.module.css';

interface OutsideAnnouncementBannerProps extends HTMLProps<HTMLDivElement> {
    localStorageKey: string;
    dismissable: boolean;
    message: string;
    // The text of the button
    cta?: string;
    // The button link
    href?: string;
}

export default function OutsideAnnouncement({
    localStorageKey,
    dismissable,
    message,
    cta,
    href,
    ...props
}: OutsideAnnouncementBannerProps) {
    const [shouldShowBanner, setShowBanner] = usePersistentState(
        `outsideAnnouncement__${localStorageKey}`,
        true
    );

    return (
        <Collapse in={shouldShowBanner} className={props.className}>
            <div className={classes.container}>
                <div className={classes.content}>
                    <Typography variant='body2' align='center'>
                        {message}
                    </Typography>

                    {cta && (
                        <OutsideButton
                            appearance='secondary'
                            size='small'
                            href={href}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            {cta}
                        </OutsideButton>
                    )}
                </div>

                {dismissable && (
                    <IconButton
                        aria-label='Close'
                        onClick={() => setShowBanner(false)}
                        className={classes.button}
                        size='large'
                    >
                        <Close />
                    </IconButton>
                )}
            </div>
        </Collapse>
    );
}
